import React from 'react';
import { Carousel, Button } from 'react-bootstrap'
import { WELCOME_SCREEN } from './logic';
const Welcome = () =>
(
    <div className="Welcome">
      <Carousel>

        {
          WELCOME_SCREEN.map(elem =>
          (
            <Carousel.Item interval={10000} key={elem.id}>
              <a href={elem.link}>
                <img
                  className="d-block w-100"
                  src={elem.img}
                  alt={elem.alt}
                /></a>
              <Carousel.Caption>
                <h1>{elem.caption}</h1>
                <Button variant={elem.color} href={elem.link}><h3>{elem.buttonText}</h3></Button>
              </Carousel.Caption>
            </Carousel.Item>
          ))
        }
      </Carousel>
    </div>
  )

export default Welcome;